import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { createItemCategory, updateItemCategory } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

export const EditItemCategory = ({
  showModal,
  setShowModal,
  fetchCategory,
  selectedCategory,
  fetchdata,
  AddorEdit,
}) => {
  const { showLoader, hideLoader, shopItem, UserItem, selectedWarehouse } = useContext(WarehouseContext);
  const [ware_id] = useState(selectedWarehouse?.id);
  const [shop_id] = useState(shopItem?.id);
  const [formData, setFormData] = useState({
    category: "",
    shop_id: shopItem?.shop_id || "0",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData({
      ...formData,
      category: selectedCategory?.categories || "",
    });
  }, [selectedCategory]);

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();
    const validationErrors = {};
    if (!shop_id) {
      toast.error("Shop id is required!");
      hideLoader();
      return;
    }

    if (!formData.category) {
      validationErrors.category = "Category title is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }

    const payload = {
      categories: formData.category,
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    };

    try {
      if (AddorEdit) {
        await createItemCategory(payload);
        hideLoader();
        toast.success("Category Added successfully");
      } else {
        await updateItemCategory(selectedCategory?.id, payload);
        hideLoader();
        toast.success("Category Updated successfully");
      }
      setShowModal(false);
      fetchCategory();
      if (fetchdata) fetchdata();
    } catch (error) {
      hideLoader();
      console.error("Error Category data:", error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      if (!/^[A-Za-z\s]*$/.test(value)) return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleclear = () => {
    setShowModal(false);
    setErrors({
      category: "",
    });
    setFormData({
      category: "",
    });
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {selectedCategory ? "Edit Category" : "Add Category"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleclear()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-3 text-normal">Category</label>
                    <div className="col-8">
                      <input
                        type="text"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className="form-control text-normal"
                      />
                      {errors.category && (
                        <small className="text-danger">{errors.category}</small>
                      )}
                    </div>
                  </div>
                  <div className="mt-5">
                    <button
                      type="submit"
                      className="btn btn-success float-end text-normal rounded-1"
                    >
                      {selectedCategory ? "Update Category" : "Add Category"}
                    </button>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                      onClick={() => handleclear()}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
